module.exports = __webpack_public_path__ + "img/edit.54494e4d.svg";